<template>
  <div>
    <div id="notification-container"></div>
    <div id="content-body">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
:root {
  --header-height: 0px;
  --background-color: #e5e5e5;
  --primary: #2a2a2a;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bolder !important;
}

*, html, body {
  scroll-behavior: smooth;
}

section {
  position: relative;

  z-index: 10;
  width: 100%;
  height: calc(100vh - var(--header-height));
}

#content-body {
  height: calc(100vh - var(--header-height));
  width: 100%;
  background: var(--background-color);
  overflow-y: auto;
}

.overlayedCard {
  color: white !important;
  text-align: center;
}

@media screen and (max-width: 830px) {
  section {
    height: unset;
    min-height: calc(100vh - var(--header-height));
  }
}
</style>